import type { FormCreateOption, FormCreateOptionItem } from './types'

function normalizeBtn(
  btn: boolean | FormCreateOptionItem | undefined
): boolean | FormCreateOptionItem | undefined {
  if (btn == null || typeof btn === 'boolean') return btn
  const { text, innerText, ...rest } = btn
  return {
    ...rest,
    innerText: innerText ?? text,
  }
}

export function normalizeFormCreateOption(
  option: FormCreateOption | undefined
): FormCreateOption {
  const next = { ...(option ?? {}) } as FormCreateOption & {
    submitBtn?: boolean | FormCreateOptionItem
    resetBtn?: boolean | FormCreateOptionItem
  }
  if (next.submitBtn && typeof next.submitBtn === 'object') {
    next.submitBtn = normalizeBtn(next.submitBtn)
  }
  if (next.resetBtn && typeof next.resetBtn === 'object') {
    next.resetBtn = normalizeBtn(next.resetBtn)
  }
  return next
}
